<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="133"></ucMenu>
					<div class="right_con">
						<div class="record_main">
							<el-card shadow="never" style="margin-bottom: 10px;">
								<div class="product_info">
									<img :src="productInfo.img" style="width:90px;height: 90px">
									<div class="right_box">
										<p class="title">
											{{ productInfo.name }}
											<i class="iconfont icon-shuoming" style="font-size: 14px"></i>
											<span class="copy_id" @click="copyText(productInfo.outer_product_id)">复制ID</span>
										</p>
<!--										<p class="shop_info">-->
<!--											店铺-->
<!--											<span class="shop_name">{{ productInfo.shop?.shop_name }}</span>-->
<!--										</p>-->
										<p class="price">￥{{ productInfo.origin_discount_price }}</p>
									</div>
								</div>
							</el-card>
							<el-card shadow="never" style="margin-bottom: 10px;">
								<div class="data_wrap">
									<div class="top_box">
										<div class="title">数据概览</div>
									</div>
									<div class="data_box">
										<div class="data_item" v-for="(item,index) in data_type_list" :key="index">
											<p class="name">{{ item.name }}</p>
											<p class="val">{{ item.val }}</p>
										</div>
									</div>
								</div>
							</el-card>
							<el-card shadow="never" style="margin-bottom: 10px;">
								<div class="data_wrap">
									<div class="top_box" style="margin-bottom: 20px;padding-bottom: 16px;border-bottom: 1px solid #EEEEEE;">
										<div class="title">筛选</div>
										<div class="reset" @click="resetSearch"><i class="iconfont icon-reset1"></i> 重置</div>
									</div>
									<div class="top_box">
										<div class="filter">
											<div class="filter_item" style="padding-left: 0">
												<el-select v-model="selectTimeKeys" placeholder="付款时间" @change="changeKeys" style="width: 120px">
													<el-option
														v-for="item in timeKeysList"
														:key="item.value"
														:label="item.label"
														:value="item.value">
													</el-option>
												</el-select>
												<el-date-picker
													style="border:none;width: 200px;font-size: 14px;padding: 0;"
													v-model="selectDay"
													type="daterange"
													range-separator="-"
													size="mini"
													@change="changeDate"
													value-format="yyyy-MM-dd"
													start-placeholder="开始日期"
													end-placeholder="结束日期">
												</el-date-picker>
											</div>
											<div class="filter_item">
												用户名
												<el-select v-model="selectBusiness" filterable placeholder="请选择或输入" @change="changeBusiness" style="height: 36px;">
													<el-option
														v-for="item in businessList"
														:key="item.id"
														:label="item.nickname"
														:value="item.id">
													</el-option>
												</el-select>
											</div>
											<div class="filter_item">
												店铺名
												<el-select v-model="selectShop" filterable placeholder="请选择或输入" @change="changeShop" style="height: 36px;">
													<el-option
														v-for="item in shopList"
														:key="item.id"
														:label="item.shop_name"
														:value="item.shop_id">
													</el-option>
												</el-select>
											</div>
										</div>
									</div>
								</div>
							</el-card>
							<el-card shadow="never" style="min-height:650px;">
								<div class="data_wrap">
									<div class="top_box">
										<div class="ranking">
											<span class="rank_item" :class="{active:rank_type == 2}" @click="changeRankType(2)">明细数据</span>
											<span class="rank_item" :class="{active:rank_type == 1}" @click="changeRankType(1)">店铺排行</span>
											<!--											<span class="rank_item" :class="{active:rank_type == 3}" @click="changeRankType(3)">用户排行</span>-->
										</div>
										<div class="filter">

										</div>
									</div>
								</div>
								<el-table highlight-current-row @selection-change="selection" row-key="id" :header-cell-style="{ background: '#eef1f6', color: '#606266', width: '50px' }" v-loading="loading" ref="multipleTable" class="eltable eltable_one" :data="list" style="width: 100%;margin-top: 20px;" v-if="rank_type == 1">
									<el-table-column align="center" property="scope" label="TOP" width="50">
										<template slot-scope="scope">
											<img :src="'https://admin.v2.xinghaohuo.com/assets/images/rank_'+scope.row.ranking+'.png'" v-if="scope.row.ranking < 4"/>
											<span v-if="scope.row.ranking >= 4">{{ scope.row.ranking }}</span>
										</template>
									</el-table-column>
									<el-table-column align="left" property="shop_name" label="店铺名" width="150"></el-table-column>
									<el-table-column align="center" property="all_sales" label="全店营业额" width=""></el-table-column>
									<el-table-column align="center" property="all_sales_orders" label="订单量" width=""></el-table-column>
									<el-table-column align="center" property="all_purchase" label="采购量" width=""></el-table-column>
									<el-table-column align="center" property="all_purchase_amount" label="采购成本" width=""></el-table-column>
									<el-table-column align="center" property="all_refund_num" label="退货退款量" width=""></el-table-column>
									<el-table-column align="center" property="all_refund_fee" label="退货退款额" width=""></el-table-column>
									<el-table-column align="center" property="all_purchase_fee" label="采购费" width=""></el-table-column>
									<el-table-column align="center" property="all_total_profit" label="毛利润" width=""></el-table-column>
								</el-table>
								<el-table highlight-current-row @selection-change="selection" row-key="id" :header-cell-style="{ background: '#eef1f6', color: '#606266', width: '50px' }" v-loading="loading" ref="multipleTable" class="eltable eltable_two" :data="productList" style="width: 100%;margin-top: 20px;" v-if="rank_type == 2">
									<el-table-column align="center" property="scope" label="序号" width="50">
										<template slot-scope="scope">
											<span>{{ scope.row.ranking }}</span>
										</template>
									</el-table-column>
									<el-table-column align="center" property="time_str" label="时间" width=""></el-table-column>
									<el-table-column align="center" property="sales" label="全部销售额" width=""></el-table-column>
									<el-table-column align="center" property="sales_orders" label="全部单数" width=""></el-table-column>
									<el-table-column align="center" property="purchase_amount" label="全部采购额" width=""></el-table-column>
									<el-table-column align="center" property="total_profit" label="全部毛利" width=""></el-table-column>
									<el-table-column align="center" property="profit_rate" label="全部毛利率" width="">
										<template slot-scope="scope">
											{{ scope.row.profit_rate }}%
										</template>
									</el-table-column>
									<el-table-column align="center" property="refund_num" label="全部退单数" width=""></el-table-column>
									<el-table-column align="center" property="refund_rate" label="全部退单率" width="">
										<template slot-scope="scope">
											{{ scope.row.refund_rate }}%
										</template>
									</el-table-column>
								</el-table>
								<el-table highlight-current-row @selection-change="selection" row-key="id" :header-cell-style="{ background: '#eef1f6', color: '#606266', width: '50px' }" v-loading="loading" ref="multipleTable" class="eltable eltable_three" :data="list" style="width: 100%;margin-top: 20px;" v-if="rank_type == 3">
									<el-table-column align="center" property="scope" label="TOP" width="50">
										<template slot-scope="scope">
											<img :src="'https://admin.v2.xinghaohuo.com/assets/images/rank_'+scope.row.ranking+'.png'" v-if="scope.row.ranking < 4"/>
											<span v-if="scope.row.ranking >= 4">{{ scope.row.ranking }}</span>
										</template>
									</el-table-column>
									<el-table-column align="center" property="business_mobile" label="手机号" width=""></el-table-column>
									<el-table-column align="center" property="business_name" label="用户名" width=""></el-table-column>
									<el-table-column align="center" property="all_sales" label="全店营业额" width=""></el-table-column>
									<el-table-column align="center" property="all_sales_orders" label="订单量" width=""></el-table-column>
									<el-table-column align="center" property="all_purchase" label="采购量" width=""></el-table-column>
									<el-table-column align="center" property="all_purchase_amount" label="采购成本" width=""></el-table-column>
									<el-table-column align="center" property="all_refund_num" label="退货退款量" width=""></el-table-column>
									<el-table-column align="center" property="all_refund_fee" label="退货退款额" width=""></el-table-column>
									<el-table-column align="center" property="all_purchase_fee" label="采购费" width=""></el-table-column>
									<el-table-column align="center" property="all_total_profit" label="毛利润" width=""></el-table-column>
								</el-table>
								<div class="turn_page">
									<Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getRanking" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10,50,100]" v-if="rank_type != 2"/>
									<Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getProductList" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10,50,100]" v-if="rank_type == 2"/>
								</div>
							</el-card>
						</div>
					</div>
				</div>
			</div>
		</div>
		<myFoot></myFoot>
	</div>
</template>
<script>
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import myHead from "@/components/myHead/myhead.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import {mapActions, mapState} from "vuex";
import Pagination from "@/components/pagination/pagination.vue";

export default {
	name: "ucenterStatistic",
	data() {
		return {
			rangeTime: "",
			startTime: "",
			endTime: "",
			tableData: [],
			statisticData: {},
			list: [],
			searchData: {},
			productInfo: {},
			compare_str: '',
			rank_type: 2,
			daySelect: [
				{id: 1, name: '今天', day: '0'},
				{id: 2, name: '昨天', day: '1'},
				{id: 3, name: '近7天', day: '7'},
				{id: 4, name: '近30天', day: '30'},
				{id: 5, name: '近60天', day: '60'},
				{id: 6, name: '近90天', day: '90'},
				{id: 7, name: '近180天', day: '180'},
				{id: 8, name: '近一年', day: '365'},
				{id: 9, name: '本月', day: 'this_month'},
				{id: 10, name: '上月', day: 'prev_month'},
			],
			daySelectId: 1,
			selectDay: "",
			page_data: {
				page: 1,
				limit: 10,
				total: 0
			},
			data_type_list: [],
			express_data_type_list: [
				{id: 1, name: '圆通', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 2, name: '申通', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 3, name: '中通', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 4, name: '韵达', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 5, name: '极兔', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 6, name: '京东', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 7, name: '邮政', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 8, name: '顺丰', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 9, name: '其他', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 10, name: '合计', val: '--', rate: 0 + '%', rate_type: 1}

			],
			express_output_type_list: [
				{id: 1, name: '圆通', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 2, name: '邮政', val: '--', rate: 0 + '%', rate_type: 1},
				{id: 3, name: '合计', val: '--', rate: 0 + '%', rate_type: 1}
			],
			productList: [],
			shopList: [],
			selectShop: '',
			businessList: [],
			selectBusiness: '',
			keysList: [{
				value: 'product_name',
				label: '商品名称',
			}],
			selectKeys: 'product_name',
			keys_input: '',
			timeKeysList: [{
				value: 'pay_time',
				label: '付款时间',
			}],
			selectTimeKeys: 'pay_time',
		}
	},
	components: {
		Pagination,
		myHead, myFoot, ucMenu
	},
	computed: {
		...mapState({
			userinfo: (state) => state.login.userinfo,
		}),
	},
	created() {
		let goods_id = this.$route.query.goods_id
		this.searchData.goods_id = goods_id
		this.index()
		this.getRanking()
		this.getProductList()
		this.refreshTimer = setInterval(() => {
			this.index()
		}, 5000);
	},
	beforeDestroy() {
		clearInterval(this.refreshTimer)
	},
	methods: {
		...mapActions({
			getStatisticProductDetailData: "ucenter/opGetStatisticProductDetailData",
			getStatisticShopProductRanking: "ucenter/opGetStatisticShopProductRanking",
			getStatisticProductList: "ucenter/opGetStatisticProductList",
			checkBind: "ucenter/uShareBillCheckBind",
		}),
		changeRankType(type) {
			this.rank_type = type
			this.page_data.page = 1
			if (type == 2) {
				this.getProductList()
			} else {
				this.getRanking();
			}
		},
		changeShop() {
			this.searchData.shop_id = this.selectShop
			this.getRanking()
			this.index()
		},
		changeBusiness() {
			this.searchData.business_user_id = this.selectBusiness
			this.getRanking()
			this.index()
		},
		changeKeys() {
			this.searchData.keys = this.selectKeys
		},
		changeKeysInput() {
			this.getRanking()
		},
		index() {
			let params = {
				page: this.page,
				page_size: this.page_size,
			}
			params = Object.assign(params, this.searchData)
			this.getStatisticProductDetailData({
				data: params,
				success: (res) => {
					if (res.code === 200) {
						console.log('get share bill data', res)
						this.data_type_list = res.data.list
						this.shopList = res.data.shop_list
						this.businessList = res.data.business_user_list
						this.productInfo = res.data.productInfo
					} else {
						this.$message({message: res.msg, type: 'error',});
					}
				}
			})
		},
		getRanking() {
			let params = {limit: this.page_data.limit, page: this.page_data.page, type: this.rank_type, keys: this.selectKeys, keys_input: this.keys_input}
			Object.assign(params, this.searchData)
			this.loading = true
			this.getStatisticShopProductRanking({
				data: params,
				success: (res) => {
					if (res.code === 200) {
						this.list = res.data.list.data
						this.page_data.total = res.data.list.total
						this.loading = false
					} else {
						this.$message({message: res.msg, type: 'error',});
					}
				}
			})
		},
		getProductList() {
			let params = {limit: this.page_data.limit, page: this.page_data.page, type: this.rank_type, keys: this.selectKeys, keys_input: this.keys_input}
			Object.assign(params, this.searchData)
			this.loading = true
			this.getStatisticProductList({
				data: params,
				success: (res) => {
					if (res.code === 200) {
						this.productList = res.data.list.data
						this.page_data.total = res.data.list.total
						this.loading = false
					} else {
						this.$message({message: res.msg, type: 'error',});
					}
				}
			})
		},
		resetSearch() {
			this.selectDay =  ''
			this.searchData.start_time = ''
			this.searchData.end_time = ''
			this.searchData.shop_id = ''
			this.searchData.business_user_id = ''
			this.searchData.select_day = ''
			this.index()
			this.getRanking()
			this.getProductList()
		},
		changeDate(e) {
			console.log(this.selectDay)
			if (this.selectDay) {
				this.searchData.start_time = this.selectDay[0];
				this.searchData.end_time = this.selectDay[1]
				this.daySelectId = ''
				this.searchData.select_day = ''
			} else {
				this.searchData.start_time = ''
				this.searchData.end_time = ''
				this.daySelectId = 1
				this.searchData.select_day = this.daySelect[0].day
			}

			this.index()
			this.getRanking()
			this.getProductList()
		},
		daySelectClick(e) {
			console.log(e)
			this.selectDay = ''
			this.searchData.start_time = ''
			this.searchData.end_time = ''
			this.daySelectId = e.id
			this.searchData.select_day = e.day
			this.index()
			this.getRanking()
			this.getProductList()
		},
		selection(selection) {
			this.ids = selection.map(item => item.id)
			this.single = selection.length == 0
		},
		copyText(text) {
			var input = document.createElement("input"); // 创建input对象
			input.value = text; // 设置复制内容
			document.body.appendChild(input); // 添加临时实例
			input.select(); // 选择实例内容
			document.execCommand("Copy"); // 执行复制
			document.body.removeChild(input); // 删除临时实例
			this.$message({
				message: '复制成功',
				type: 'success'
			});

		},
		currentChange(val) {
			this.page = val
			this.getShareBill()
			console.log(val)
		}
	}
}

</script>

<style scoped>
.wrap .wrap_body {
	display: flex;
	flex-direction: column;
}

.center {
	display: flex;
	flex: 1;
}

.ucenter_main {
	padding: 30px 0 40px;
	display: flex;
	justify-content: space-between;
	flex: 1;
}

.right_con {
	width: 980px;
}

:deep(.el-card__body) {
	padding: 12px 18px;
}

.data_wrap .top_box {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.data_wrap .top_box .title {
	font-weight: bold;
	font-size: 14px;
	color: #000000;
}

.data_wrap .top_box .reset {
	font-size: 14px;
	color: #737E97;
	cursor: pointer;
}

.data_wrap .top_box .reset .iconfont {
	font-size: 14px;
	color: #737E97;
	transform:  scale(-1, -1);
}

.data_wrap .top_box .filter {
	display: flex;
	font-weight: 400;
	font-size: 14px;
	color: #737E97;
	min-height: 32px;
}

.data_wrap .top_box .filter .filter_item {
	border-radius: 6px;
	border: 1px solid #DCDFE6;
	display: flex;
	align-items: center;
	padding-left: 15px;
	margin-right: 19px;
	white-space: nowrap;
}

.data_wrap .top_box .filter .filter_item .day_select {
	border-right: 1px solid #E1EBFE;
	height: 14px;
	line-height: 14px;
	padding-right: 10px;
	margin-right: 10px;
	cursor: pointer;
}

.data_wrap .top_box .filter .filter_item .day_select.active {
	color: #236CFF;
}

.data_wrap .top_box .filter .filter_item .day_select:last-child {
	border-right: none;
	margin-right: 0px;
}

.data_wrap .top_box .filter .filter_item:last-child {
	margin-right: 0px;
}

.data_wrap .top_box .filter .tips_box {
	display: flex;
	align-items: center;
}

.data_wrap .top_box .filter .tips_box .desc {
	display: flex;
	align-items: center;
	border-right: 2px solid #E1EBFE;
	line-height: 15px;
	padding-right: 10px;
	margin-right: 10px;
}

.data_wrap .top_box .filter .tips_box .iconfont {
	font-size: 12px;
	color: #737E97;
	margin-left: 3px;
}

.data_wrap .data_box {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-wrap: wrap;
	margin-top: 20px;
}

.data_wrap .data_box .data_item {
	width: 110px;
	background: #FFFFFF;
	border-radius: 6px;
	box-shadow: 0 0 15px 2px rgba(236, 243, 255, 0);
	margin-right: 10px;
	margin-bottom: 20px;
}


.data_wrap .data_box .data_item .name {
	font-size: 12px;
	color: #454545;
	margin-bottom: 10px;
}

.data_wrap .data_box .data_item .val {
	font-weight: normal;
	font-size: 22px;
	color: #000000;
}

.data_wrap .data_box .data_item .rate {
	font-weight: 400;
	font-size: 14px;
	color: #454545;
	white-space: nowrap;
}

.data_wrap .data_box .data_item .rate .rate_val {
	color: #2CD9C5;
}

.data_wrap .data_box .data_item .rate .rate_val .iconfont {
	margin: 0 6px;
	display: inline-block;
}

.data_wrap .data_box .data_item .rate .rate_val.active {
	color: #F52929;
}

.data_wrap .data_box .data_item .rate .rate_val.active .iconfont {
	transform: scaleY(-1);
}

.data_wrap .top_box .ranking {
	height: 36px;
	border-radius: 6px;
	border: 1px solid #DCDFE6;
	display: flex;
	align-items: center;
	padding: 0 2px;
}

.data_wrap .top_box .ranking .rank_item {
	width: 80px;
	height: 30px;
	background: #FFFFFF;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #737E97;
	font-size: 14px;
	cursor: pointer;
}

.data_wrap .top_box .ranking .rank_item.active {
	background: #F0413E;
	color: #fff;
}


.product_info {
	display: flex;
}

.product_info .right_box {
	margin-left: 15px;
}

.product_info .right_box .title {
	font-weight: 400;
	font-size: 14px;
	color: #000000;
}

.product_info .right_box .title .copy_id {
	width: 46px;
	height: 18px;
	border-radius: 4px;
	border: 1px solid #236CFF;
	font-size: 12px;
	color: #236CFF;
	cursor: pointer;
	margin-left: 5px;
}

.product_info .right_box .shop_info {
	font-size: 12px;
	color: #737E97;
	
}

.product_info .right_box .shop_info .shop_name {
	color: #000000;
	margin-left: 6px;
}

.product_info .right_box .price {
	font-weight: bold;
	font-size: 14px;
	color: #F53F3F;
	margin-top: 35px;
}

:deep(.filter_item .el-range-editor--mini .el-range-separator) {
	line-height: 36px !important;
}

:deep(.filter_item .el-input__inner) {
	border: none !important; /* 或者使用其他自定义边框样式 */
	height: 36px !important;
}

:deep(.el-table th.el-table__cell>.cell) {
	padding: 0 !important;
}

.el-table th {
	white-space: nowrap;
}

:deep(.eltable_one .el-table__cell:nth-child(2)>.cell) {
	padding-left: 10px !important;
}

:deep(.eltable_two .el-table__cell:nth-child(3)>.cell) {
	padding-left: 10px !important;
}

:deep(.el-date-editor) {
	margin-top: 0 !important;
}

.el-table .cell {
	white-space: nowrap;
	text-overflow: initial;
}

.turn_page {
	display: flex;
	justify-content: flex-end;
	margin-top: 10px;
}
</style>